"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsStyle = void 0;
const typestyle_1 = require("typestyle");
const controlsStyle = () => ({
    zIndex: 30,
    position: 'absolute',
    width: '100%',
    bottom: 0,
    padding: '0 16px',
    boxSizing: 'border-box',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    userSelect: 'none',
    opacity: 0,
    transition: 'opacity 0.2s'
});
exports.ControlsStyle = (0, typestyle_1.stylesheet)({
    controls: Object.assign({}, controlsStyle()),
    controlsVisible: Object.assign(Object.assign({}, controlsStyle()), { opacity: 1 }),
    buttons: {
        height: '100%',
        display: 'flex',
        position: 'relative',
        justifyContent: 'space-between',
        marginBottom: '6px',
        alignItems: 'center'
    },
    button: {
        width: '32px',
        height: '32px',
        padding: '7px',
        boxSizing: 'border-box',
        cursor: 'pointer'
    },
    mapButton: {
        width: '42px', height: '42px', padding: '5px', cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '30px', lineHeight: '1'
    },
    left: {
        display: 'flex',
        alignItems: 'center',
        $nest: {
            '& .button': {
                marginRight: '8px'
            }
        }
    },
    povTitle: {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        maxWidth: '42%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        color: '#eee',
        fontSize: '12px',
        pointerEvents: 'none',
        textAlign: 'center'
    },
    playbackSpeed: {
        minWidth: '35px',
        marginRight: '8px',
        color: '#d7e7ff',
        fontSize: '11px',
        textAlign: 'center',
        whiteSpace: 'nowrap'
    },
    right: {
        display: 'flex',
        alignItems: 'center',
        width: '218px',
        height: '100%',
        justifyContent: 'flex-end',
        gap: '12px'
    }
});
